function __extends(d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var DEFAULT_HYDRATION_IDENTIFIER = 'glitz';

function parseDeclarationBlock(declarations) {
    var block = '';
    var property;
    for (property in declarations) {
        var value = declarations[property];
        if (typeof value === 'object') {
            for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
                var fallback = value_1[_i];
                if (block) {
                    block += ';';
                }
                block += parseDeclaration(property, fallback);
            }
        }
        else {
            if (block) {
                block += ';';
            }
            block += parseDeclaration(property, value);
        }
    }
    return block;
}
function parseDeclaration(property, value) {
    if (process.env.NODE_ENV !== 'production') {
        if (!(typeof value === 'string' || typeof value === 'number')) {
            console.error('The style value %O of property `%s` has to be a string, number', value, property);
        }
        if (value === '') {
            console.warn('Style property `%s` as empty string may cause some unexpected behavior', property);
        }
        if (typeof value === 'number' && Number.isNaN(value)) {
            console.warn('Style property `%s` as NaN may cause some unexpected behavior', property);
        }
        if (typeof value === 'number' && !Number.isFinite(value)) {
            console.warn('Style property `%s` as an infinite number may cause some unexpected behavior', property);
        }
    }
    return hyphenateProperty(property) + ":" + value;
}
// Accept both camel cased and capitalized vendor properties
var hyphenateRegex = /(?:^(ms|moz|webkit))|[A-Z]/g;
var propertyCache = {};
function hyphenateProperty(property) {
    return property in propertyCache
        ? propertyCache[property]
        : (propertyCache[property] = property.replace(hyphenateRegex, '-$&').toLowerCase());
}

var validateMixingShorthandLonghand = function () {
    // noop
};
if (process.env.NODE_ENV !== 'production') {
    var borderWidth = ['border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width'];
    var borderStyle = ['border-top-style', 'border-right-style', 'border-bottom-style', 'border-left-style'];
    var borderColor = ['border-top-color', 'border-right-color', 'border-bottom-color', 'border-left-color'];
    var shorthands_1 = {
        animation: [
            'animation-name',
            'animation-duration',
            'animation-timing-function',
            'animation-delay',
            'animation-iteration-count',
            'animation-direction',
            'animation-fill-mode',
            'animation-play-state',
        ],
        background: [
            'background-image',
            'background-position',
            'background-size',
            'background-repeat',
            'background-origin',
            'background-clip',
            'background-attachment',
            'background-color',
        ],
        border: ['border-width', 'border-style', 'border-color'].concat(borderWidth, borderStyle, borderColor),
        'border-bottom': ['border-bottom-width', 'border-bottom-style', 'border-bottom-color'],
        'border-color': borderColor,
        'border-image': [
            'border-image-source',
            'border-image-slice',
            'border-image-width',
            'border-image-outset',
            'border-image-repeat',
        ],
        'border-left': ['border-left-width', 'border-left-style', 'border-left-color'],
        'border-radius': [
            'border-top-left-radius',
            'border-top-right-radius',
            'border-bottom-right-radius',
            'border-bottom-left-radius',
        ],
        'border-right': ['border-right-width', 'border-right-style', 'border-right-color'],
        'border-style': borderStyle,
        'border-top': ['border-top-width', 'border-top-style', 'border-top-color'],
        'border-width': borderWidth,
        'column-rule': ['column-rule-width', 'column-rule-style', 'column-rule-color'],
        columns: ['column-width', 'column-count'],
        cue: ['cue-before', 'cue-after'],
        flex: ['flex-grow', 'flex-shrink', 'flex-basis'],
        'flex-flow': ['flex-direction', 'flex-wrap'],
        font: ['font-style', 'font-variant', 'font-weight', 'font-stretch', 'font-size', 'line-height', 'font-family'],
        'font-variant': [
            'font-variant-ligatures',
            'font-variant-alternates',
            'font-variant-caps',
            'font-variant-numeric',
            'font-variant-east-asian',
        ],
        grid: [
            'grid-template-rows',
            'grid-template-columns',
            'grid-template-areas',
            'grid-auto-rows',
            'grid-auto-columns',
            'grid-auto-flow',
        ],
        'grid-area': ['grid-row-start', 'grid-column-start', 'grid-row-end', 'grid-column-end'],
        'grid-column': ['grid-column-start', 'grid-column-end'],
        'grid-row': ['grid-row-start', 'grid-row-end'],
        'grid-template': ['grid-template-rows', 'grid-template-columns', 'grid-template-areas'],
        'list-style': ['list-style-type', 'list-style-position', 'list-style-image'],
        margin: ['margin-top', 'margin-right', 'margin-bottom', 'margin-left'],
        mask: ['mask-image', 'mask-mode', 'mask-position', 'mask-size', 'mask-repeat', 'mask-origin', 'mask-clip'],
        'mask-border': [
            'mask-border-source',
            'mask-border-slice',
            'mask-border-width',
            'mask-border-outset',
            'mask-border-repeat',
            'mask-border-mode',
        ],
        outline: ['outline-width', 'outline-style', 'outline-color'],
        padding: ['padding-top', 'padding-right', 'padding-bottom', 'padding-left'],
        pause: ['pause-before', 'pause-after'],
        'place-content': ['align-content', 'justify-content'],
        'place-items': ['align-items', 'justify-items'],
        'place-self': ['align-self', 'justify-self'],
        rest: ['rest-before', 'rest-after'],
        'text-decoration': ['text-decoration-line', 'text-decoration-style', 'text-decoration-color'],
        'text-emphasis': ['text-emphasis-style', 'text-emphasis-color'],
        transition: ['transition-property', 'transition-duration', 'transition-timing-function', 'transition-delay'],
    };
    validateMixingShorthandLonghand = function (object, classNames) {
        var hyphenatedProperties = Object.keys(object).reduce(function (properties, property) {
            if (typeof object[property] === 'object' && !Array.isArray(object[property])) {
                validateMixingShorthandLonghand(object[property], classNames);
            }
            properties[hyphenateProperty(property)] = property;
            return properties;
        }, {});
        for (var property in hyphenatedProperties) {
            if (property in shorthands_1) {
                for (var _i = 0, _a = shorthands_1[property]; _i < _a.length; _i++) {
                    var longhand = _a[_i];
                    if (longhand in hyphenatedProperties) {
                        console.warn('Injected style resulting in class name `%s` had a longhand property `%s` mixed with its corresponding shorthand property `%s` in %O which may likely cause some unexpected behavior. Replace `%s` with longhand properties to solve the issue.', classNames, hyphenatedProperties[longhand], hyphenatedProperties[property], object, hyphenatedProperties[property]);
                    }
                }
            }
        }
    };
}

function formatRule(identifier, block) {
    return identifier + "{" + block + "}";
}
function formatClassRule(className, block, pseudo) {
    if (pseudo === void 0) { pseudo = ''; }
    return "." + formatRule(className + pseudo, block);
}
function formatKeyframesRule(name, blockList) {
    return "@keyframes " + formatRule(name, blockList);
}
function formatFontFaceRule(name, block) {
    return "@font-face {" + block + ";font-family:" + name + "}";
}

var ANIMATION_NAME = 'animationName';
var FONT_FAMILY = 'fontFamily';
var Injector = /** @class */ (function () {
    function Injector(plainIndex, pseudoIndex, keyframesIndex, fontFaceIndex, incrementClassHash, incrementKeyframesHash, incrementFontFaceHash, injectNewClassRule, injectNewKeyframesRule, injectNewFontFaceRule) {
        this.injectClassName = function (declarations, pseudo) {
            var block = parseDeclarationBlock(declarations);
            var index = pseudo ? (pseudoIndex[pseudo] = pseudoIndex[pseudo] || {}) : plainIndex;
            if (index[block]) {
                return index[block];
            }
            var className = incrementClassHash();
            index[block] = className;
            if (injectNewClassRule) {
                injectNewClassRule(className, block, pseudo);
            }
            return className;
        };
        this.injectKeyframes = function (declarationList) {
            var blockList = '';
            for (var identifier in declarationList) {
                var keyframeBlock = parseDeclarationBlock(declarationList[identifier]);
                blockList += formatRule(identifier, keyframeBlock);
            }
            if (keyframesIndex[blockList]) {
                return keyframesIndex[blockList];
            }
            var name = incrementKeyframesHash();
            keyframesIndex[blockList] = name;
            if (injectNewKeyframesRule) {
                injectNewKeyframesRule(name, blockList);
            }
            return name;
        };
        this.injectFontFace = function (original) {
            if (process.env.NODE_ENV !== 'production') {
                if (FONT_FAMILY in original) {
                    console.warn('The CSS property `%s` in font face will be ignored in %O', FONT_FAMILY, original);
                }
            }
            var declarations = {};
            var property;
            for (property in original) {
                if (property !== FONT_FAMILY) {
                    declarations[property] = original[property];
                }
            }
            var block = parseDeclarationBlock(declarations);
            if (fontFaceIndex[block]) {
                return fontFaceIndex[block];
            }
            var name = incrementFontFaceHash();
            fontFaceIndex[block] = name;
            if (injectNewFontFaceRule) {
                injectNewFontFaceRule(name, block);
            }
            return name;
        };
    }
    return Injector;
}());

var NON_ATOMIC_KEY = '$';
var MEDIA_IDENTIFIER = '@';
var PSEUDO_IDENTIFIER = ':';
var Base = /** @class */ (function () {
    function Base(injector, transformer, atomic) {
        var resolve = function (style, theme, result, media, pseudo) {
            if (result === void 0) { result = {}; }
            var properties = Object.keys(style);
            for (var i = properties.length; i > 0; i--) {
                var property = properties[i - 1];
                var value = style[property];
                if (typeof value === 'function') {
                    value = value(theme);
                }
                if (process.env.NODE_ENV !== 'production') {
                    if (value === null || ['undefined', 'string', 'number', 'object'].indexOf(typeof value) === -1) {
                        console.error('The style value %O of property `%s` has to be a string, number, plain object or array', value, property);
                    }
                    else if ((typeof value === 'object' && Object.keys(value).length === 0) || String(value).trim() === '') {
                        console.warn('The style property `%s` in %O was an empty %s and should be removed because it can cause unexpected behavior', property, style, Array.isArray(value) ? 'array' : typeof value);
                    }
                }
                if (property === '@keyframes') {
                    property = ANIMATION_NAME;
                }
                if (property === '@font-face') {
                    property = FONT_FAMILY;
                }
                if (property === ANIMATION_NAME ||
                    property === FONT_FAMILY ||
                    // String, number or undefined
                    typeof value !== 'object' ||
                    Array.isArray(value)) {
                    var declarations = getIndex(result, media, pseudo);
                    if (!(property in declarations)) {
                        if (property === ANIMATION_NAME && typeof value === 'object' && !Array.isArray(value)) {
                            // Resolve `animationName` objects
                            var list = {};
                            for (var identifier in value) {
                                var block = reverse(resolve(value[identifier], theme));
                                list[identifier] = transformer ? transformer(block) : block;
                            }
                            value = injector().injectKeyframes(list);
                        }
                        if (property === FONT_FAMILY && typeof value === 'object') {
                            // Resolve `fontFace` object
                            var families = [].concat(value);
                            var names = '';
                            for (var _i = 0, families_1 = families; _i < families_1.length; _i++) {
                                var family = families_1[_i];
                                if (names) {
                                    names += ',';
                                }
                                if (typeof family === 'object') {
                                    var fontFace = reverse(resolve(family, theme));
                                    names += injector().injectFontFace((transformer ? transformer(fontFace) : fontFace));
                                }
                                else {
                                    names += family;
                                }
                            }
                            value = names;
                        }
                        declarations[property] = value;
                    }
                    continue;
                }
                // Media or pseudo
                if (property[0] === MEDIA_IDENTIFIER || property[0] === PSEUDO_IDENTIFIER) {
                    resolve(value, theme, result, property[0] === MEDIA_IDENTIFIER ? property : media, property[0] === PSEUDO_IDENTIFIER ? (pseudo || '') + property : pseudo);
                    continue;
                }
                // Shorthand objects
                var longhandDeclarations = {};
                for (var extension in value) {
                    var longhandValue = value[extension];
                    var alias = false;
                    if (extension === 'x' || extension === 'xy') {
                        alias = true;
                        longhandDeclarations[property + 'Left'] = longhandValue;
                        longhandDeclarations[property + 'Right'] = longhandValue;
                    }
                    if (extension === 'y' || extension === 'xy') {
                        alias = true;
                        longhandDeclarations[property + 'Top'] = longhandValue;
                        longhandDeclarations[property + 'Bottom'] = longhandValue;
                    }
                    if (!alias) {
                        longhandDeclarations[property + extension[0].toUpperCase() + extension.slice(1)] = longhandValue;
                    }
                }
                resolve(longhandDeclarations, theme, result, media, pseudo);
            }
            return result;
        };
        var injectClassName = function (declarations, media, pseudo) {
            return injector(media).injectClassName(transformer ? transformer(declarations) : declarations, pseudo);
        };
        var cache = {};
        var inject = atomic === false
            ? // Non-atomic style
                function (style, media, pseudo) {
                    var classNames = '';
                    var keys = Object.keys(style);
                    var blocks = {};
                    for (var i = keys.length - 1; i >= 0; i--) {
                        var key = keys[i];
                        if (style[key] === undefined) {
                            continue;
                        }
                        var object = key[0] === MEDIA_IDENTIFIER || key[0] === PSEUDO_IDENTIFIER
                            ? // Media or pseudo
                                blocks
                            : // Group declarations
                                (blocks[NON_ATOMIC_KEY] = blocks[NON_ATOMIC_KEY] || {});
                        object[key] = style[key];
                    }
                    for (var rule in blocks) {
                        if (rule === NON_ATOMIC_KEY) {
                            classNames += ' ' + injectClassName(blocks[rule], media, pseudo);
                        }
                        else {
                            classNames += inject(blocks[rule], rule[0] === MEDIA_IDENTIFIER ? rule.slice(7) : media, rule[0] === PSEUDO_IDENTIFIER ? rule : pseudo);
                        }
                    }
                    return classNames;
                }
            : // Atomic style
                function (result, media, pseudo) {
                    var _a;
                    var classNames = '';
                    var properties = Object.keys(result);
                    var index = getIndex(cache, media, pseudo);
                    for (var i = properties.length - 1; i >= 0; i--) {
                        var property = properties[i];
                        var value = result[property];
                        if (value === undefined) {
                            continue;
                        }
                        // Media or pseudo
                        if (property[0] === MEDIA_IDENTIFIER || property[0] === PSEUDO_IDENTIFIER) {
                            classNames += inject(value, property[0] === MEDIA_IDENTIFIER ? property.slice(7) : media, property[0] === PSEUDO_IDENTIFIER ? property : pseudo);
                            continue;
                        }
                        var declaration = (_a = {}, _a[property] = value, _a);
                        if (typeof value === 'string' || typeof value === 'number') {
                            // Only supports caching of primitive values
                            var cachedValues = (index[property] = index[property] || {});
                            if (value in cachedValues) {
                                classNames += ' ' + cachedValues[value];
                                continue;
                            }
                            var className = injectClassName(declaration, media, pseudo);
                            classNames += ' ' + (cachedValues[value] = className);
                            continue;
                        }
                        // Array
                        classNames += ' ' + injectClassName(declaration, media, pseudo);
                    }
                    return classNames;
                };
        this.injectStyle = function (styles, theme) {
            var result = {};
            if (Array.isArray(styles)) {
                for (var i = styles.length - 1; i >= 0; i--) {
                    resolve(styles[i], theme, result);
                }
            }
            else {
                resolve(styles, theme, result);
            }
            var classNames = inject(result);
            if (process.env.NODE_ENV !== 'production') {
                validateMixingShorthandLonghand(result, classNames);
            }
            return classNames.slice(1);
        };
    }
    return Base;
}());
function getIndex(indexes, media, pseudo) {
    var index = indexes;
    if (media) {
        index = (index[media] = index[media] || {});
    }
    if (pseudo) {
        return (index[pseudo] = index[pseudo] || {});
    }
    else {
        return index;
    }
}
function reverse(object) {
    var reversed = {};
    var properties = Object.keys(object);
    for (var i = properties.length; i > 0; i--) {
        reversed[properties[i - 1]] = object[properties[i - 1]];
    }
    return reversed;
}

function injectSheetRule(styleElement, rule) {
    var sheet = styleElement.sheet;
    var index = sheet.cssRules.length;
    try {
        sheet.insertRule(rule, index);
    }
    finally {
        // Ignore failing rules
    }
}
function createStyleElement(media, identifier) {
    var element = document.createElement('style');
    if (media) {
        element.media = media;
    }
    element.dataset[identifier] = '';
    return element;
}
function insertStyleElement(element, insertBefore) {
    document.head.insertBefore(element, insertBefore);
    return element;
}

function createHashCounter(prefix) {
    if (prefix === void 0) { prefix = ''; }
    var count = 0;
    var offset = 10;
    var msb = 35;
    var power = 1;
    var increment = function () {
        var virtualCount = count + offset;
        if (virtualCount === msb) {
            offset += (msb + 1) * 9;
            msb = Math.pow(36, ++power) - 1;
        }
        count++;
        // Skip "ad" due to ad-blockers
        if (virtualCount === 373) {
            return increment();
        }
        return prefix + virtualCount.toString(36);
    };
    return increment;
}

// tslint:disable no-conditional-assignment
var CLASS_RULE_REGEX = /\.([a-z0-9]+)(:[^{]+)?\{([^}]+)\}/g;
var KEYFRAMES_REGEX = /@keyframes ([a-z0-9]+)\{((?:[a-z0-9%]+\{[^}]+\})+)\}/g;
var FONT_FACE_REGEX = /@font-face \{(.+);font-family:([^}]+)\}/g;
var InjectorClient = /** @class */ (function (_super) {
    __extends(InjectorClient, _super);
    function InjectorClient(styleElement, incrementClassHash, incrementKeyframesHash, incrementFontFaceHash) {
        var _this = this;
        var plainIndex = {};
        var pseudoIndex = {};
        var keyframesIndex = {};
        var fontFaceIndex = {};
        // Hydrate
        var css = styleElement.textContent;
        if (css) {
            var rule = void 0;
            while ((rule = CLASS_RULE_REGEX.exec(css))) {
                incrementClassHash();
                var index = rule[2] ? (pseudoIndex[rule[2]] = pseudoIndex[rule[2]] || {}) : plainIndex;
                index[rule[3]] = rule[1];
            }
            while ((rule = KEYFRAMES_REGEX.exec(css))) {
                incrementKeyframesHash();
                keyframesIndex[rule[2]] = rule[1];
            }
            while ((rule = FONT_FACE_REGEX.exec(css))) {
                incrementFontFaceHash();
                fontFaceIndex[rule[1]] = rule[2];
            }
        }
        var injectNewClassRule = function (className, block, pseudo) {
            var rule = formatClassRule(className, block, pseudo);
            injectSheetRule(styleElement, rule);
        };
        var injectNewKeyframesRule = function (name, blockList) {
            var rule = formatKeyframesRule(name, blockList);
            injectSheetRule(styleElement, rule);
        };
        var injectNewFontFaceRule = function (name, block) {
            var rule = formatFontFaceRule(name, block);
            injectSheetRule(styleElement, rule);
        };
        _this = _super.call(this, plainIndex, pseudoIndex, keyframesIndex, fontFaceIndex, incrementClassHash, incrementKeyframesHash, incrementFontFaceHash, injectNewClassRule, injectNewKeyframesRule, injectNewFontFaceRule) || this;
        return _this;
    }
    return InjectorClient;
}(Injector));

var GlitzClient = /** @class */ (function (_super) {
    __extends(GlitzClient, _super);
    function GlitzClient(options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        var prefix = options.prefix;
        var classHasher = createHashCounter(prefix);
        var keyframesHasher = createHashCounter(prefix);
        var fontFaceHasher = createHashCounter(prefix);
        var mediaOrderOption = options.mediaOrder;
        var mediaSheets = {};
        var initialMediaSheet = null;
        var plain;
        var mediaIndex = {};
        var identifier = options.identifier || DEFAULT_HYDRATION_IDENTIFIER;
        var injector = function (media) {
            if (media) {
                if (mediaIndex[media]) {
                    return mediaIndex[media];
                }
                var element = (mediaSheets[media] = createStyleElement(media, identifier));
                var insertBefore = null;
                if (mediaOrderOption) {
                    var orderedMediaKeys = Object.keys(mediaSheets).sort(mediaOrderOption);
                    initialMediaSheet = mediaSheets[orderedMediaKeys[0]];
                    insertBefore = mediaSheets[orderedMediaKeys[orderedMediaKeys.indexOf(media) + 1]] || null;
                }
                insertStyleElement(element, insertBefore);
                return (mediaIndex[media] = new InjectorClient(element, classHasher, keyframesHasher, fontFaceHasher));
            }
            else {
                if (plain) {
                    return plain;
                }
                var element = insertStyleElement(createStyleElement(media, identifier), initialMediaSheet);
                return (plain = new InjectorClient(element, classHasher, keyframesHasher, fontFaceHasher));
            }
        };
        _this = _super.call(this, injector, options.transformer, options.atomic) || this;
        var preRenderStyles = document.head.querySelectorAll("[data-" + identifier + "]");
        if (preRenderStyles) {
            for (var _i = 0, preRenderStyles_1 = preRenderStyles; _i < preRenderStyles_1.length; _i++) {
                var element = preRenderStyles_1[_i];
                // Injector for style elements without `media` is stored with an empty key. So if there's any reason to have
                // more than one of these in the future we need to change that part.
                var media = element.media;
                if (media) {
                    if (!initialMediaSheet) {
                        initialMediaSheet = element;
                    }
                    mediaSheets[media] = element;
                    mediaIndex[media] = new InjectorClient(element, classHasher, keyframesHasher, fontFaceHasher);
                }
                else {
                    plain = new InjectorClient(element, classHasher, keyframesHasher, fontFaceHasher);
                }
            }
            if (process.env.NODE_ENV !== 'production') {
                if (mediaOrderOption) {
                    // Verify hydrated style element order
                    var medias = Object.keys(mediaSheets);
                    var orderedMedias = medias.sort(mediaOrderOption);
                    for (var index in medias) {
                        if (medias[index] !== orderedMedias[index]) {
                            console.warn('The order of media queries rendered by the server did not meet the expected ' +
                                'order by the browser. Make sure you pass the same function to the `mediaOrder`' +
                                'option for both `GlitzServer` and `GlitzClient`.');
                            break;
                        }
                    }
                }
            }
        }
        return _this;
    }
    return GlitzClient;
}(Base));

var InjectorServer = /** @class */ (function (_super) {
    __extends(InjectorServer, _super);
    function InjectorServer(incrementClassHash, incrementKeyframesHash, incrementFontFaceHash) {
        var _this = this;
        var plainIndex = {};
        var pseudoIndex = {};
        var keyframesIndex = {};
        var fontFaceIndex = {};
        _this = _super.call(this, plainIndex, pseudoIndex, keyframesIndex, fontFaceIndex, incrementClassHash, incrementKeyframesHash, incrementFontFaceHash) || this;
        _this.getStyle = function () {
            var css = '';
            for (var block in plainIndex) {
                css += formatClassRule(plainIndex[block], block);
            }
            for (var pseudo in pseudoIndex) {
                var index = pseudoIndex[pseudo];
                for (var block in index) {
                    css += formatClassRule(index[block], block, pseudo);
                }
            }
            for (var blockList in keyframesIndex) {
                css += formatKeyframesRule(keyframesIndex[blockList], blockList);
            }
            for (var block in fontFaceIndex) {
                css += formatFontFaceRule(fontFaceIndex[block], block);
            }
            return css;
        };
        return _this;
    }
    return InjectorServer;
}(Injector));

var GlitzServer = /** @class */ (function (_super) {
    __extends(GlitzServer, _super);
    function GlitzServer(options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        var prefix = options.prefix;
        var classHasher = createHashCounter(prefix);
        var keyframesHasher = createHashCounter(prefix);
        var fontFaceHasher = createHashCounter(prefix);
        var plain;
        var mediaIndex = {};
        var injector = function (media) {
            return media
                ? (mediaIndex[media] = mediaIndex[media] || new InjectorServer(classHasher, keyframesHasher, fontFaceHasher))
                : (plain = plain || new InjectorServer(classHasher, keyframesHasher, fontFaceHasher));
        };
        _this = _super.call(this, injector, options.transformer, options.atomic) || this;
        _this.getStyleMarkup = function () {
            var identifier = options.identifier || DEFAULT_HYDRATION_IDENTIFIER;
            var markup = '';
            if (plain) {
                markup += "<style data-" + identifier + ">" + plain.getStyle() + "</style>";
            }
            var medias = options.mediaOrder ? Object.keys(mediaIndex).sort(options.mediaOrder) : Object.keys(mediaIndex);
            for (var _i = 0, medias_1 = medias; _i < medias_1.length; _i++) {
                var media = medias_1[_i];
                markup += "<style data-" + identifier + " media=\"" + media + "\">" + mediaIndex[media].getStyle() + "</style>";
            }
            return markup;
        };
        return _this;
    }
    return GlitzServer;
}(Base));

// Unfortunately we need this until there's a way to have index signatures for
// other types like: https://github.com/Microsoft/TypeScript/issues/7765.
// This is a work around that works thanks to dynamic properties.
function media(list, style) {
    var _a;
    return _a = {}, _a["@media " + (typeof list === 'string' ? list : query(list))] = style, _a;
}
function query(list) {
    if (process.env.NODE_ENV !== 'production') {
        if (Object.keys(list).length === 0) {
            console.warn('The media query is empty and will therefor be ignored. Prefer not having empty media queries');
        }
    }
    var result = '';
    var feature;
    for (feature in list) {
        if (result) {
            result += ' and ';
        }
        var value = list[feature];
        result += value === true ? "(" + hyphenateProperty(feature) + ")" : "(" + hyphenateProperty(feature) + ": " + value + ")";
    }
    return result;
}

// Unfortunately we need this until there's a way to have index signatures for
// other types like: https://github.com/Microsoft/TypeScript/issues/7765.
// This is a work around that works thanks to dynamic properties.
function pseudo(value, style) {
    var _a;
    // TODO Pseudo validation
    return _a = {}, _a[value] = style, _a;
}

function compose() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return fns.reduceRight(function (prevFn, nextFn) { return function (arg) { return nextFn(prevFn(arg)); }; });
}

export { GlitzClient, GlitzServer, media, query, pseudo, compose, DEFAULT_HYDRATION_IDENTIFIER };
